module.exports = __webpack_public_path__ + "img/temu.03072c85.svg";